import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getAxiosInstance } from "../../../utils/axiosInstance";
import { Accordion, AccordionButton, AccordionIcon, AccordionItem, AccordionPanel, Box, Button, Text } from "@chakra-ui/react";
import CategoryRecursion from "./CategoryRecursion";
import PageHead from "../../../components/PageHead";
import AddCategoryProduct from "./AddModal";
import AddSubCategoryModal from "./AddSubCategoryModel";
import { useTranslation } from "react-i18next";
import { FaRegFolderOpen } from "react-icons/fa";

export type Category = {
  id: string,
  name: string,
  isDeleted: boolean,
  createdAt: string,
  updatedAt: string,
  subCategories: Category[] | []
};

const SingleCategoryPage = () => {
  const { id } = useParams();

  const [data, setData] = useState<Category>();
  const [addModal, setAddModal] = useState<boolean>(false);
  const { t } = useTranslation("translations");

  const fetchData = async () => {
    try {
      const res = await getAxiosInstance().get('Categories/' + id);
      setData(res.data)
    } catch (e) {

    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className=" p-2">
        <PageHead
          addTooltip={t("Add Subcategory")}
          name={data?.name ? data.name.toUpperCase() : t("Category")}
          onAddModal={() => { setAddModal(true) }}
        />

        {
          data && data.subCategories.map((x, index) => <CategoryRecursion key={`category_${index}_${x.name}`} category={x} catComponent={null} resetData={() => fetchData()} />)
        }
        {
          data && data.subCategories.length === 0 &&
          <div className="w-full flex flex-col justify-center items-center opacity-80">
            <FaRegFolderOpen className="w-[300px] h-[250px]" />
            <div className="text-[32px]">
              {t("NO_DATA_IN_TABLE")}
            </div>
          </div>
        }

        <AddSubCategoryModal
          isOpen={addModal}
          onClose={() => {
            setAddModal(false)
            fetchData();
          }}
          id={data?.id ? data?.id : ""}
          resetData={() => fetchData()}
        />
      </div>
    </div>
  )
}

export default SingleCategoryPage;